import { BlockReferenceArray } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import { BlockHeaderContent } from '@/cms/BlockHeaderContentDC';
import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { ImageStrapiProps } from '@/decodo/components/atoms/Image/ImageStrapi';
import { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { AuthorStrapiProps } from '@/decodo/components/organisms/author/AuthorStrapi';
import { PostTopic } from '@/decodo/features/shared/BlogMetaData/PostTags';

import { SSR_getRelatedArticlesToRender } from './utils';
import { ArticleItemStrapi } from './RelatedArticleItemStrapi';

export type MetadataStrapiProps = {
  slug: string;
  metadata: {
    image: ImageStrapiProps;
    releaseDate: string;
    timeSpentReading: number;
    newUntil?: string;
    title: string;
    description: RichTextFieldStrapiProps;
    topics: BlockReferenceArray<PostTopic>;
    author: AuthorStrapiProps['blogAuthor'];
  };
};
export interface RelatedArticlesStrapiProps {
  title: string;
  articles: BlockReferenceArray<MetadataStrapiProps>;
  blog_author: {
    blogAuthor: AuthorStrapiProps['blogAuthor'];
  };
}

export async function RelatedArticlesStrapi({
  block,
  ...rest
}: BlockComponentModel<RelatedArticlesStrapiProps>) {
  if (typeof window !== 'undefined') {
    console.warn(
      'RelatedArticlesStrapi is being rendered on the client-side. This component is intended for server-side rendering only. Please ensure it is used in a server-side context.'
    );
  }
  const { title } = block;

  /**
   * At build time check if the related articles block has an author assigned.
   * If it does, fetch the articles related to that author.
   *
   * If the block does not have an author assigned,
   * render the articles that were already assigned to the block.
   */
  const articlesToRender = await SSR_getRelatedArticlesToRender(block);

  return (
    <BlockWrapper
      {...rest}
      data-tracker-section={SECTION_NAMES.RELATED_ARTICLES}
    >
      <div>
        <BlockHeaderContent title={title}>
          <div className={'grid gap-8 md:grid-cols-2 md:gap-x-9 md:gap-y-12'}>
            {articlesToRender?.data?.map((item, index) => (
              <ArticleItemStrapi key={index} slug={item.attributes.slug} />
            ))}
          </div>
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
